import axios from "axios";

const basePath = process.env.NODE_ENV === "production" ? "/api/" : "";

//API UI
const getCountryList = () => {
  return axios.get("/v1/Country", { baseURL: basePath }).then((response) => {
    return response.data;
  });
};

const getAPIProductCategoryList = () => {
  return axios
    .get("/v1/APIProductCategory/Normal", { baseURL: basePath })
    .then((response) => {
      return response.data;
    });
};

const getAPIProductNameList = () => {
  return axios
  .get("/v1/APIProductCategory/APIProductCategoryName", {baseURL: basePath})
  .then((response) => {
    return response.data;
  })
}

//Token
const generateToken = (appId, secretKey) => {
  return axios.post(
    "/Token/Generate/",
    {
      appId,
      secretKey,
    },
    { baseURL: basePath }
  );
};

//Sandbox
const APIProcessTransaction = (method, body, inbound, request, token) => {
  if (method === "POST") {
    return axios
      .post(inbound, JSON.parse(request), {
        headers: { Authorization: "Bearer " + token },
        baseURL: basePath,
      })
      .then((response) => {
        return response.data;
      });
  } else {
    return axios
      .get(inbound, {
        headers: { Authorization: "Bearer " + token },
        baseURL: basePath,
      })
      .then((response) => {
        return response.data;
      });
  }
};

export default {
  APIProcessTransaction,
  generateToken,
  getCountryList,
  getAPIProductCategoryList,
  getAPIProductNameList
};
